<template>
    <LoadingComponent />
</template>

<script src="./js/exampleError.js"></script>